import en from "./en/index";

export default {
  ...en,
  language: {
    switch: "Switch Language Success",
  },
  role: {
    permission: "Permission",
  },
  user: {
    uname: "User Name",
    role: "Role",
    sex: "Sex",
    account: {
      info: "Account",
      logout: "Log out",
    },
  },
  action: {
    success: "Operation Succeeded",
    error: "Operation Failed",
    delete:
      "This operation will permanently delete this record. Do you want to continue?",
    logout: "Are you sure you want to log out?",
    delSuccess: "Delete successful",
    tips: "Tips",
    confirm: "Are you sure you want to submit the form?",
    cancel: "Cancel",
    confirmBtn: "Confirm",
    examine: "Examine",
    submit: "Submit",
    accountLoginWarning:
      "Your account has been logged in abnormally. If this was not your action, please conduct a security check as soon as possible",
  },
};
